import React from 'react';
import { t } from 'Src/i18n';
import { capitalizeName } from 'Utils/label/labelUtils';
import {
  getDiffAbsoluteDays,
  formatTime,
  formatDate,
} from 'Components/widgets/transport-details/transportUtils';
type TransportDetailsTravelSectionBoundProps = {
  isDeparture: boolean;
  firstDeparture: TravelSectionBound;
  travelSectionBound: TravelSectionBound;
};
export function TransportDetailsTravelSectionBound({
  isDeparture,
  travelSectionBound,
  firstDeparture,
}: TransportDetailsTravelSectionBoundProps) {
  const time = formatTime(travelSectionBound.time || '', t('common.timeFormat')) || '';
  const label = capitalizeName(travelSectionBound.airportLabel || travelSectionBound.label);
  const daysAfter = getDiffAbsoluteDays(firstDeparture.date, travelSectionBound.date);
  const terminal = travelSectionBound.terminalCode
    ? t('common.transport.terminalCode', {
        terminalcode: travelSectionBound.terminalCode,
      })
    : null;
  return (
    <div data-testid="TransportDetailsTravelSectionBound" className="flex items-start gap-20">
      <p className="text-16 font-semibold leading-normal">{time}</p>
      <div>
        <p className="text-16 font-semibold leading-normal">{label}</p>
        {daysAfter ? (
          <span className="text-12 font-semibold text-sienna">
            {`(${t(`booking.transport.${isDeparture ? 'departureNextDay' : 'arrivalNextDay'}`)} ${formatDate(travelSectionBound.date, t('booking.priceDetails.packagePrice.dateFormat'))})`}
          </span>
        ) : null}
        {terminal && <p className="text-12 font-normal">{terminal}</p>}
      </div>
    </div>
  );
}
